// One physical content box for all thermal documents. Values are millimetres.
export function receiptGeometry(settings = {}) {
  const custom = Number(settings.custom_paper_width ?? 80);
  const paper = settings.paper === 'custom' && Number.isFinite(custom) && custom >= 40 && custom <= 210
    ? custom : String(settings.paper) === '58' ? 58 : 80;
  const printable = Math.round((paper - (paper <= 58 ? 10 : 8)) * 100) / 100;
  const margin = (value, fallback) => value != null && value !== '' && Number.isFinite(Number(value)) && Number(value) >= 0 && Number(value) <= 15 ? Number(value) : fallback;
  let left = margin(settings.receipt_margin_left_mm, 4), right = margin(settings.receipt_margin_right_mm, 2);
  if (left + right > printable - 10) { left = 4; right = 2; }
  return { paper, printable, left, right, content: Math.round((printable - left - right) * 100) / 100 };
}
export function receiptBoxCss(settings = {}) {
  const g = receiptGeometry(settings);
  return `width: ${g.printable}mm; max-width: 100%; margin: 0; padding: 2mm ${g.right}mm 2mm ${g.left}mm; box-sizing: border-box;`;
}
export function escposGeometry(settings = {}) {
  const g = receiptGeometry(settings), left = Math.round(g.left * 8), dots = Math.round(g.content * 8);
  return { columns: Math.max(8, Math.floor(dots / 12)), commands: [29,76,left & 255,left >> 8,29,87,dots & 255,dots >> 8] };
}
